export default "__VITE_ASSET__GwlW9p51__"